import {
    HttpContextToken,
    HttpErrorResponse,
    HttpEvent,
    HttpHandler,
    HttpInterceptor,
    HttpRequest,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, Observable, throwError } from 'rxjs';
import { ApiErrorHandlerService, ApiError } from '@/core/services/api-error-handler.service';

/** API error codes that the caller of a request handles itself, so no toast is shown for them. */
export const SILENT_API_ERROR_CODES = new HttpContextToken<readonly string[]>(() => []);

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
    constructor(private readonly apiErrorHandler: ApiErrorHandlerService) {}

    public intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
        return next.handle(req).pipe(
            catchError((err: HttpErrorResponse) => {
                if (err.error.error) {
                    const apiError = err.error.error as ApiError;
                    apiError.httpCode = err.status;
                    const silent = req.context.get(SILENT_API_ERROR_CODES).includes(apiError.code);
                    if (!silent && this.handleError(apiError)) {
                        // return EMPTY;
                        return throwError(() => err);
                    }
                }
                // console.error('Error intercepted:', err);
                return throwError(() => err);
            }),
        );
    }

    private handleError(error: ApiError): boolean {
        return this.apiErrorHandler.handleError(error);
    }
}
